import {connect} from '../../app/connect';
import IssueNewPanel from './IssueNewPanel';
import {changeLocationAction} from '../../app/actions';

const mapStateToProps = (/*state*/) => ({});

const mapDispatchToProps = {
  changeLocationAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueNewPanel);
